import React, { useState } from "react";
import ContactInfoCard from "./ContactInfoCard";
import DataLoader from "../../../../../components/Loaders/DataLoader/DataLoader";
import RecentActivityCard from "../../../Leads/LeadsDetails/LeadOverview/RecentActivityCard";
import NoDataWithoutImage from "../../../../../components/NoData/NoDataWithoutImage";
import ContactOverviewTimeline from "./ContactOverviewTimeline";
import {
  handleUploadImgFile,
  startApiCall,
} from "../../../../../global-functions/globalFunctions";
import { CrmContactRelatedEndPoints } from "../../../../../api/Endpoints";
import { useSelector } from "react-redux";
import ApiCall from "../../../../../api/ApiCall";
import { toast } from "react-toastify";

const ContactDetailsLeft = ({
  taskLoader,
  contactDetails,
  loader,
  allActivity,
  setmoreInfoModal,
  settimelineDetails,
  setEditContactData,
  id,
  handleGetContactById,
  setactivityDetails,
  dealCount,
  setShowDealDetails,
  handleGetMandatoryTask,
  totalCounts,
}) => {
  const { user } = useSelector((state) => state);
  const [selectTab, setSelectTab] = useState("Personal info");
  const [isUploading, setisUploading] = useState(false);
  const handleTabChange = (mode) => {
    setSelectTab(mode);
  };

  const tabs = [
    {
      name: "Personal info",
      icon: (
        <svg
          width="16"
          height="16"
          viewBox="0 0 12 16"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M5.99875 7.75649C5.31879 7.75658 4.65408 7.55503 4.08868 7.17734C3.52327 6.79964 3.08256 6.26276 2.82229 5.63459C2.56202 5.00642 2.49387 4.31518 2.62647 3.64828C2.75906 2.98138 3.08645 2.36877 3.56721 1.88794C4.04798 1.40711 4.66054 1.07964 5.32742 0.946952C5.99431 0.814265 6.68556 0.882318 7.31377 1.1425C7.94197 1.40269 8.47891 1.84332 8.85669 2.40868C9.23446 2.97403 9.43609 3.63872 9.43609 4.31867C9.43522 5.23009 9.07281 6.10394 8.42839 6.74845C7.78396 7.39296 6.91017 7.75549 5.99875 7.75649ZM5.99875 1.87227C5.51476 1.87217 5.04162 2.01561 4.63916 2.28444C4.2367 2.55328 3.92301 2.93542 3.73775 3.38255C3.5525 3.82967 3.504 4.3217 3.5984 4.79639C3.6928 5.27108 3.92585 5.70711 4.26808 6.04934C4.61031 6.39157 5.04634 6.62463 5.52103 6.71902C5.99572 6.81342 6.48775 6.76493 6.93488 6.57967C7.382 6.39441 7.76415 6.08072 8.03298 5.67826C8.30181 5.2758 8.44525 4.80266 8.44516 4.31867C8.44441 3.67008 8.18643 3.04825 7.7278 2.58963C7.26917 2.131 6.64735 1.87301 5.99875 1.87227ZM11.4864 15.1191H0.511093L0.015625 14.6237C0.015625 13.838 0.170383 13.0599 0.471063 12.334C0.771743 11.6081 1.21246 10.9486 1.76804 10.393C2.32363 9.83738 2.9832 9.39667 3.70911 9.09599C4.43501 8.79531 5.21303 8.64055 5.99875 8.64055C6.78446 8.64055 7.56249 8.79531 8.28839 9.09599C9.0143 9.39667 9.67387 9.83738 10.2295 10.393C10.785 10.9486 11.2258 11.6081 11.5264 12.334C11.8271 13.0599 11.9819 13.838 11.9819 14.6237L11.4864 15.1191ZM1.03 14.1282H10.9675C10.8463 12.8945 10.2705 11.75 9.35212 10.9173C8.43372 10.0847 7.2384 9.62354 5.99875 9.62354C4.7591 9.62354 3.56378 10.0847 2.64538 10.9173C1.72697 11.75 1.15117 12.8945 1.03 14.1282Z" />
        </svg>
      ),
    },
    {
      name: "Contact info",
      icon: (
        <svg
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M17.2647 12.7223C17.1102 12.7223 16.9486 12.673 16.7941 12.6377C16.4811 12.5686 16.1735 12.4767 15.8738 12.363C15.5478 12.2441 15.1896 12.2502 14.868 12.3803C14.5463 12.5104 14.284 12.7552 14.1315 13.0675L13.9769 13.3846C13.2927 13.0028 12.6639 12.5287 12.1082 11.9755C11.5566 11.4181 11.0838 10.7875 10.7032 10.1013L10.9983 9.90402C11.3097 9.75107 11.5538 9.48799 11.6835 9.16541C11.8132 8.84284 11.8193 8.48355 11.7008 8.15669C11.5892 7.85543 11.4977 7.5471 11.4268 7.23371C11.3917 7.0787 11.3636 6.91665 11.3425 6.7546C11.2572 6.25831 10.998 5.80889 10.6116 5.48725C10.2252 5.16561 9.73701 4.9929 9.23492 5.00022H7.12735C6.82459 4.99737 6.52477 5.05998 6.2483 5.18379C5.97182 5.30759 5.7252 5.48968 5.5252 5.71767C5.32521 5.94566 5.17655 6.21419 5.08933 6.50498C5.00211 6.79577 4.9784 7.10199 5.01979 7.4028C5.39405 10.3545 6.73818 13.097 8.83986 15.1972C10.9415 17.2973 13.681 18.6354 16.6255 19H16.8924C17.4105 19.0008 17.9106 18.8101 18.2975 18.4645C18.5197 18.2652 18.6972 18.0208 18.8184 17.7475C18.9395 17.4742 19.0014 17.1783 19 16.8792V14.7655C18.9914 14.2761 18.8137 13.8049 18.4972 13.4323C18.1807 13.0596 17.7451 12.8087 17.2647 12.7223ZM17.616 16.9497C17.6159 17.0497 17.5945 17.1486 17.5533 17.2397C17.5121 17.3308 17.4521 17.4121 17.3772 17.4781C17.2987 17.5461 17.2069 17.5969 17.1077 17.6272C17.0085 17.6575 16.904 17.6668 16.8011 17.6543C14.1701 17.3159 11.7262 16.1088 9.85505 14.2232C7.98387 12.3377 6.79184 9.88101 6.46698 7.24075C6.4558 7.13754 6.4656 7.03314 6.49579 6.93383C6.52598 6.83453 6.57592 6.7424 6.64261 6.66301C6.70845 6.58785 6.78948 6.52762 6.88033 6.48631C6.97118 6.44501 7.06976 6.42358 7.16951 6.42345H9.27707C9.44044 6.41981 9.59997 6.47339 9.72819 6.57498C9.85642 6.67658 9.94532 6.81982 9.97959 6.98006C10.0077 7.17264 10.0428 7.36288 10.085 7.55076C10.1661 7.92217 10.2741 8.28716 10.4081 8.64284L9.4246 9.10081C9.34051 9.13951 9.26486 9.19448 9.20201 9.26258C9.13916 9.33067 9.09034 9.41055 9.05836 9.49762C9.02637 9.58469 9.01185 9.67724 9.01563 9.76996C9.0194 9.86267 9.0414 9.95372 9.08037 10.0379C10.0914 12.2099 11.8323 13.9559 13.998 14.9699C14.1691 15.0403 14.3609 15.0403 14.5319 14.9699C14.6195 14.9384 14.7001 14.8899 14.7688 14.827C14.8375 14.7641 14.8931 14.6881 14.9324 14.6035L15.3679 13.6171C15.7311 13.7474 16.1018 13.8556 16.4779 13.9412C16.6653 13.9835 16.8549 14.0187 17.047 14.0469C17.2067 14.0813 17.3496 14.1704 17.4509 14.299C17.5522 14.4276 17.6056 14.5876 17.602 14.7515L17.616 16.9497Z" />
        </svg>
      ),
    },
    {
      name: "Attachment",
      icon: (
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.9968 6.99996L8.49677 13.5C8.09895 13.8978 7.87545 14.4374 7.87545 15C7.87545 15.5626 8.09895 16.1021 8.49677 16.5C8.8946 16.8978 9.43416 17.1213 9.99677 17.1213C10.5594 17.1213 11.0989 16.8978 11.4968 16.5L17.9968 9.99996C18.7924 9.20432 19.2394 8.12518 19.2394 6.99996C19.2394 5.87475 18.7924 4.79561 17.9968 3.99996C17.2011 3.20432 16.122 2.75732 14.9968 2.75732C13.8716 2.75732 12.7924 3.20432 11.9968 3.99996L5.49677 10.5C4.3033 11.6934 3.63281 13.3121 3.63281 15C3.63281 16.6878 4.3033 18.3065 5.49677 19.5C6.69025 20.6934 8.30895 21.3639 9.99677 21.3639C11.6846 21.3639 13.3033 20.6934 14.4968 19.5L20.9968 13"
            stroke="#979797"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
    },
  ];

  const handleAddAttachment = async (event) => {
    let isError = false;
    startApiCall(null, setisUploading);
    let uploaded;
    if (event) {
      try {
        uploaded = await handleUploadImgFile(event);
      } catch (error) {
        isError = true;
        toast.error("Attachment uploading failed, try after sometimes.");
        setisUploading(false);
      }
    }
    if (!isError) {
      let attachments = {
        name: event?.target?.files[0]?.name,
        url: uploaded || "",
      };

      let allAttachment = [...contactDetails?.attachment, attachments];
      const data = {
        contactId: id,
        attachment: allAttachment,
        updatedBy: user?._id,
      };
      const res = await ApiCall(
        "post",
        CrmContactRelatedEndPoints.editContact,
        data
      );
      if (res?.success) {
        setisUploading(false);
        toast.success("Attachment Upload Successfully");
        handleGetContactById();
      } else {
        setisUploading(false);
      }
    }
  };

  const handleRemoveAttachment = async (att) => {
    let oldAtt = contactDetails?.attachment.filter((a) => a?._id !== att?._id);
    const sendData = {
      contactId: id,
      attachment: oldAtt,
      updatedBy: user?._id,
    };
    const res = await ApiCall(
      "post",
      CrmContactRelatedEndPoints.editContact,
      sendData
    );
    if (res?.success) {
      handleGetContactById();
      setisUploading(false);
      toast.success("Attachment Removed Successfully");
    } else {
      setisUploading(false);
    }
  };

  return (
    <div className="col-sm-12">
      <div className="px-3 py-2">
        <div className="d-flex gap-4 ">
          <div className="card card-border px-3 py-2 h-450p w-40 mt-3">
            <div
              className="btn-group btn-sm d-sm-flex d-none mt-2 "
              role="group"
              aria-label="Basic outlined example"
            >
              {tabs?.map((tb) => {
                return (
                  <button
                    onClick={() => {
                      handleTabChange(tb?.name);
                    }}
                    type="button"
                    className={`btn fs-7 rounded-0 ${
                      selectTab === tb?.name ? "text-primary" : ""
                    }`}
                    style={{
                      borderBottom:
                        selectTab === tb?.name ? "2px solid #1944c2" : "none",
                      transition: "border-color 0.3s ease",
                    }}
                    key={tb?.name}
                  >
                    {tb?.icon}&nbsp; {tb?.name}
                  </button>
                );
              })}
            </div>
            {loader && <DataLoader />}
            {!loader && (
              <>
                <ContactInfoCard
                  selectTab={selectTab}
                  isUploading={isUploading}
                  handleAddAttachment={handleAddAttachment}
                  contactDetails={contactDetails}
                  handleRemoveAttachment={handleRemoveAttachment}
                  setEditContactData={setEditContactData}
                  dealCount={dealCount}
                  setShowDealDetails={setShowDealDetails}
                />
              </>
            )}
          </div>
          <div className="card card-border px-3 py-2 h-450p w-60 mt-3">
            <div className="d-flex justify-content-between">
              <p className="text-semibold text-primary fs-5">
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 32 32"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M30.0019 16.0002C30.002 18.7373 29.1382 21.4046 27.5336 23.622C25.929 25.8395 23.6654 27.4938 21.0654 28.3494C18.4655 29.205 15.6618 29.2181 13.054 28.3869C10.4461 27.5556 8.16716 25.9225 6.54187 23.7202L8.15187 22.5302C9.6207 24.5251 11.7199 25.9657 14.1096 26.6189C16.4992 27.2721 19.0394 27.0995 21.3187 26.1291C23.598 25.1587 25.483 23.4473 26.6685 21.272C27.854 19.0968 28.2705 16.5851 27.8506 14.1436C27.4307 11.7022 26.199 9.47393 24.3549 7.81975C22.5108 6.16556 20.1623 5.18229 17.6898 5.02915C15.2172 4.87602 12.7653 5.56199 10.7312 6.97598C8.69709 8.38997 7.19983 10.4492 6.48187 12.8202L7.48187 12.1702L8.60188 13.8302L5.60187 15.8302C5.42511 15.9494 5.21488 16.0089 5.00187 16.0002C4.83807 16.0004 4.67672 15.9604 4.53199 15.8837C4.38727 15.807 4.2636 15.6959 4.17188 15.5602L2.17188 12.5602L3.83187 11.4402L4.51188 12.4402C5.3795 9.43438 7.30198 6.84228 9.92654 5.13955C12.5511 3.43681 15.7017 2.73767 18.8001 3.1704C21.8986 3.60314 24.737 5.13873 26.7946 7.49539C28.8522 9.85204 29.991 12.8717 30.0019 16.0002ZM16.0019 9.00018V16.0002C16.0011 16.1318 16.0263 16.2622 16.0761 16.3841C16.1259 16.5059 16.1992 16.6167 16.2919 16.7102L19.2919 19.7102L20.7119 18.2902L18.0019 15.5902V9.00018H16.0019Z" />
                </svg>
                &nbsp; Activity{" "}
                {allActivity?.length > 0 && (
                  <span className="badge badge-md  badge-pill badge-soft-primary ms-2">
                    {allActivity?.length}
                  </span>
                )}
              </p>
              <div className="d-flex align-items-center gap-2">
                <span
                  className="btn btn-sm btn-outline-primary pointer"
                  data-bs-toggle="dropdown"
                  role="button"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 21"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.2257 16.0189V5.65527M6.16406 10.8371H18.2873"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-miterlimit="10"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  &nbsp;Create
                </span>

                <div className="dropdown-menu">
                  <div
                    className="dropdown-item"
                    data-bs-toggle="modal"
                    data-bs-target="#create_call_modal"
                  >
                    Call
                  </div>
                  <div
                    className="dropdown-item"
                    data-bs-toggle="modal"
                    data-bs-target="#meeting_modal"
                  >
                    Meeting
                  </div>
                  <div
                    className="dropdown-item"
                    data-bs-toggle="modal"
                    data-bs-target="#task_modal"
                  >
                    Task
                  </div>
                </div>
              </div>
            </div>
            {!taskLoader && totalCounts?.totalCloseCount !== 0 && (
              <div
                className="progress my-2 rounded-4"
                style={{ height: "30px", background: "#e9ecef" }}
              >
                <div
                  className={`progress-bar progress-bar progress-bar-animated ${
                    totalCounts?.totalCloseCount === totalCounts?.totalCounts
                      ? "bg-success"
                      : ""
                  }`}
                  role="progressbar"
                  style={{
                    width: `${
                      totalCounts?.totalCounts
                        ? (totalCounts.totalCloseCount /
                            totalCounts.totalCounts) *
                          100
                        : 0
                    }%`,
                  }}
                  // aria-valuemin="0"
                  // aria-valuemax="100"
                >
                  {totalCounts?.totalCloseCount === totalCounts?.totalCounts ? (
                    <span className="d-flex align-items-center gap-1 justify-content-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="12"
                        fill="currentColor"
                        className="bi bi-check-square-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm10.03 4.97a.75.75 0 0 1 .011 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.75.75 0 0 1 1.08-.022z" />
                      </svg>
                      Completed
                    </span>
                  ) : (
                    <span className="fw-bold">
                      {Math.round(
                        (totalCounts.totalCloseCount /
                          totalCounts.totalCounts) *
                          100
                      ) + "%"}
                    </span>
                  )}
                </div>
              </div>
            )}
            {!taskLoader && allActivity?.length > 0 && (
              <RecentActivityCard
                allActivity={allActivity}
                setactivityDetails={setactivityDetails}
                handleGetMandatoryTask={handleGetMandatoryTask}
              />
            )}
            {taskLoader && <DataLoader title="Activity loading..." />}
            {!taskLoader && allActivity?.length === 0 && (
              <div className="d-flex justify-content-center align-items-center mt-3">
                <NoDataWithoutImage />
              </div>
            )}
          </div>
        </div>
        <div className="card card-border px-3 py-2 mnh-450p mt-3 overflow-auto col-sm-12">
          <ContactOverviewTimeline
            contactDetails={contactDetails}
            setmoreInfoModal={setmoreInfoModal}
            settimelineDetails={settimelineDetails}
          />
        </div>

        {/* <div className="card card-border mnh-150p">
          <DealsCard
            allDeals={allDeals}
            dealsLoader={dealsLoader}
            setEditDealData={setEditDealData}
          />
        </div> */}
      </div>
    </div>
  );
};

export default ContactDetailsLeft;
